// utils/API.js

import axios from "axios";

export default axios.create({
  baseURL: "https://nightoff.org/tempapi/",
  responseType: "json"
});